import { render, staticRenderFns } from "./ReviewFactoringDocument.vue?vue&type=template&id=5c4e8ad2&scoped=true&"
import script from "./ReviewFactoringDocument.vue?vue&type=script&lang=js&"
export * from "./ReviewFactoringDocument.vue?vue&type=script&lang=js&"
import style0 from "./ReviewFactoringDocument.vue?vue&type=style&index=0&id=5c4e8ad2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4e8ad2",
  null
  
)

export default component.exports